import React, {useState, useEffect, useRef} from 'react';
import PortfolioChatApi from './lib/PortfolioChatApi.js';
import styled from 'styled-components';
import MessageThreadHead from './Components/MessageThreadHead.js';
import MessageThread from './Components/MessageThread'
import PropTypes from 'prop-types';
import PortfolioChatSocket from './lib/PortfolioChatSocket';

import {MatchesContext, DataContext, StateContext } from '../App'

const portfolioChatUrl = process.env.NODE_ENV === "development" ?
"http://staging:9100/" : "https://lovemire.com/chatApi/";

const ChatDiv = styled.div`
    position: fixed;
    padding: 2px;
    background-opacity: 0;
    display: inline-block;
    width: 100%;
    bottom: -2px;
    left: 0;
    z-index: 9;
    text-align: right;
    white-space: nowrap;
    overflow-x: auto;
    padding-bottom: 0px;
    max-height: ${window.innerHeight * .8}px;

    &::-webkit-scrollbar {
        height: 8px;
       }

    /* Track */
    &::-webkit-scrollbar-track {
    background: #f1f1f1;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
    background: #888;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
    background: #555;
    }

`;

const ThreadWrapperDiv = styled.div`
    display: inline-block;
    background-color: white;
    border: 2px solid #86888D;
    border-radius: 5px 5px 0px 0px;
    padding: 0 1px;
`;


/**
 * Returns the raw json. Used by My Matches to integrate with other
 * events.
 * 
 * Returns a promise with the results.
 * 
 * @param {int} threadId 
 */
export const getMessageThreadJSON = async (toUser, page=0) => {

    try {
        let formData = new FormData();
        let obj2 = await PortfolioChatApi.postForm(`newThreadToName/${toUser}`,formData);
        
        const messagesByThreadUrl = 
        `messages/search/findAllSince?date=01/01/2019&id=${obj2.id}&`+
        `page=${page}`;

        return PortfolioChatApi.getJson(messagesByThreadUrl);

    } catch (err) {
        console.log(err)
    }

}


/**
 * Chat module will be designed to be easily portable to another
 * app. Receives function in props: user
 * This will be displayed in the position of the chat head and should
 * receive an argument id=?
 * 
 * @param {} props 
 */
const App = (props) => {

    const matches = React.useContext(MatchesContext)
    const [account,settings] = React.useContext(DataContext)
    const {profiles} = React.useContext(StateContext)

    const [ob, setOb] = useState({});
    const [newMessages, setNewMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [numNewMessages, setNumNewMessages] = useState({});
    const [singleThreadId, setSingleThreadId] = useState(-1)

    const [bubbles, setBubbles] = useState([])

    //console.log("chat app loaded", ob, loading);

    const createThreadToUser = async (toUser) => {

        console.log("Calling create thread")

        try {
            let formData = new FormData();
            let obj2 = await PortfolioChatApi.postForm(`newThreadToName/${toUser}`,formData);
            
            setSingleThreadId(obj2.id)

        } catch (err) {
            console.log(err)
        }

    }

    // receives message thread object and extracts server id of thread
    let getThreadId = (mt) => {
        
        return !!mt.id ? mt.id : parseInt(mt._links.self.href.match(/\d*$/g)[0]);
    }

    // Counts number of new messages on server
    const countNumNewMessages =  async (messageThreads) => {

        let newNum = {};

        // classic for look to handle async issues
        for (let i = 0; i < messageThreads.length; i++) {
            let mt = messageThreads[i];
            let t = await PortfolioChatApi.getJson('unSeen/' + getThreadId(mt));
            //console.log(getThreadId(mt));
            newNum[getThreadId(mt)] = parseInt(t['num']);
        }

        setNumNewMessages (newNum);
    }

    /**
     * This is where the list of threads is downloaded.
     * 
     * This gets ALL threads.
     * 
     * See getSelectedThreads
     * 
     * @returns Thread Object
     */
    const getThreads = async () => {
        let numThreads = -1;
        try {
            let obj = await PortfolioChatApi.getJson("messageThreads");
            if ( !!obj._embedded ) {
                numThreads = obj._embedded.messageThreads.length;
            }
            setOb(obj)
            console.log(obj, ob);
            countNumNewMessages(obj._embedded.messageThreads);
        } catch (err) {
            console.log("failed to load threads")
        }

        return numThreads;
    }

    const getSelectedThreads = async () => {

        let numThreads = -1;
        try {
            let obj = await PortfolioChatApi.getJson("selectedThreads");
            numThreads = obj.length
            setOb({"_embedded": {"messageThreads": obj}})
            console.log(obj, ob);
            countNumNewMessages(obj);
        } catch (err) {
            console.log("failed to load threads")
        }

        return numThreads;
    }

    const contact = async (id) => {

        try {
            let formData = new FormData();
            formData.append("id",id);
            let obj2 = await PortfolioChatApi.postForm("newThread",formData);
            
            getThreads();

        } catch (err) {
            console.log(err)
        }
    }

    // increment the numNewMessages array
    const updateNumNewMessage = (threadId) => {

        setNumNewMessages ( (prevState) => {
            prevState[threadId] = ++prevState[threadId] || 1;
            let newState = prevState;
            return newState;
        })

    }

    /**
     * Handles incoming websocket messages. This is how new messages
     * are delivered.
     * @param {} frame 
     */
    const incomingNewMessage = (frame) => {

        if (!! frame.body ) {
            
            let message = JSON.parse(frame.body);
            
            

            if ( !! message.messageThread ) {

                // Found messageThread, properly formatted message
                // push to state
                //console.log(message, ob);
                updateNumNewMessage(message.messageThread.id);
                
                addNotification(message) // adds to matches
                
                // ran into problem here with scope of stomp's callback, should
                // dig into why it's creating a new object.
                // Perhaps Stomp calls will simply need to use stateful components
                // Went too big on this functional component
                // For now, this hack will work, checks the ob state to see if 
                // this message thread exists. Sets a flag to run getThreads()
                // if necessary
                let getNewThreads = false;
                setOb ( prevState => {
                    if (prevState._embedded.messageThreads.length === 0 ||
                        !prevState._embedded.messageThreads.some ( (m) => message.messageThread.id === getThreadId(m) ) ) {
                        getNewThreads = true; 
                    }
    
                    return prevState;
                })

                // either get new threads from servers which will include messages
                // or update new messages state
                if (getNewThreads) {
                    getThreads();
                } else {
                    // TODO: check for existing
                    setNewMessages ( prevState => [...prevState,message]);
                }
                
            } else if (Array.isArray(message)) {
                // deleting ids
                // TODO: holy shit
            }
        }
    }

    const addNotification = (message) => {

        let notification = {...message}
        if (notification.messageThread) {
            // must have the messagethread to properly set message.match

            // Filter memberNames, remove the current user. Must be left with one
            let match = notification.messageThread.memberNames.filter( n => n !== matches.getUser())
            if (match.length === 1) {
                notification.match = match[0]
                matches.addNotification(notification)
            }
        }
    }


    /**
     * This is called when message threads are expanded and collaspsed. Handles
     * the new messages object.
     * 
     * @param {} reset true if newMessages should be reset
     * @param {*} thread 
     */
    const newMessagesProp = (reset = false, threadId) => {

        console.log(threadId, reset)

        if ( reset ) {

            // reset new messages and tell API messages are read
            setNewMessages( prevState => {
                let newState = [];
                prevState.forEach ( m => {
                    if (m.messageThread.id !== threadId ) {
                        // remove messages that are part of passed in thread id
                        newState.push(m);
                    }                    
                })

                return newState;
            }); // called by message thread head when hidden

            setNumNewMessages ( prevState => {
                prevState[threadId] = 0;
                return prevState;
            })

            try {
                PortfolioChatApi.putForm('seenThread/' + threadId, new FormData());
            } catch (err) {
                console.log("Caught error updating seenThread", err);
            }
            return [];

        } else {
            return newMessages;
        }
    }

    // Componenent Did Mount
    useEffect (  () => {

        /*
        How do we solve this? TODO
        */
        PortfolioChatSocket.subscribe ( 
            {route: '/secured/user', callback: f => incomingNewMessage(f) }
            );
        
        // get threads from api
        // create thread if one doesn't exist
        ( async () => {
            try {
                let numThreads = await getSelectedThreads();
                console.log("Loaded threads", numThreads)

            } catch (err) {
                console.log("error loading threads")
            }
        })();

    }, [])

    useEffect( () => {
        if (props.singleThread && singleThreadId === -1) {
            setSingleThreadId(-2)       // to avoid many loads
            createThreadToUser(props.singleThread)
        }
    }, [props])

    /**
     * To be run after message object downloaded
     * Loads the profiles necessary for thread bubble heads
     */
    useEffect ( () => {

        //console.log("ob: ", ob, account.name)
        if (!!ob && !!ob._embedded > 0) {
            let chatMembers = ob._embedded.messageThreads.map( mt => {
                return mt.memberNames.filter( mn => mn !== account.name)[0]
            })

            console.log("Add Profile Store Chat: ", chatMembers)
            matches.addProfilesStore(chatMembers)
            matches.registerProfilesCallBack ( r => {
                let rr = r.filter( p => chatMembers.includes(p.username))
                
                // Set Bubble TODO: style
                setBubbles( prevBubble => {
                    let newBubble = {}
                    rr.forEach( r => newBubble[r.username] = r.title)
                    return newBubble
                })

                // Should be finished loading necessary chat information
                setLoading(false)
            }, 'CHAT')

            matches.apiGetProfiles()      // do profiles call

            return () => {
                matches.unRegisterProfilesCallBack("APP")
            }
        }

    }, [ob])

    /**
     * Sets the x scroll of the chat div when a messagethreadhead is expanded
     * If not scrolling, does not affect.
     */
    const scrollCenter = ( (x) => {
        //console.log(x)
        if ( x['x'] + 320 > window.innerWidth) {
            console.log("Greater than width: ", threadNode.current.scrollLeft, ( (x['x'] + 320) - window.innerWidth ));
            let scrollLeft = threadNode.current.scrollLeft + 
                ( (x['x'] + 320) - window.innerWidth ) + 20;
                //threadNode.current.scrollLeft = 150;
            threadNode.current.scrollBy ( {
                left: scrollLeft, behavior: 'smooth'
            })
            console.log(threadNode.current.scrollLeft, threadNode.current.scrollHeight,scrollLeft);
        } else if ( x['x'] < 0 ) {
            console.log("Less than width: ", threadNode.current.scrollLeft, x['x']);

            let scrollRight = x['x'] - 10;

            threadNode.current.scrollBy ( {
                left: scrollRight, behavior: 'smooth'
            })

        }
    })
   
    //console.log(ob);
    //console.log(numNewMessages);


    /**
     * Needs rewrite for dealing with bubble.
     * Should access matches object and set a callback after chat knows 
     * all the usernames it needs.
     * The bubble will be stored here and passed to messagethreadhead in props
     * 
     * @param {*} id 
     * @returns 
     */

    const createBubbleHead = (id) => {
        //console.log("bubble thread head", id, bubbles)
        return !!bubbles[id] ? bubbles[id] : "Error: not found: " + id;
    }


    const threadNode = useRef();
    if ( !!threadNode && !!threadNode.current ) {
        //console.log(threadNode, threadNode.current, 
        //    threadNode.current.getBoundingClientRect(), threadNode.current.scrollLeft)
    }


    /**
     * RENDER
     */

    if (props.singleThread) {

        // returns just the message thread
        if (singleThreadId > 0) {
            return <MessageThread  user={account} 
                    threadId={singleThreadId}
                    newMessages={newMessages} >
                </MessageThread>
        } else {
            return <div>Loading...</div> 
        }

    } else {

    return (
     <ChatDiv ref={threadNode}>
      {!!loading && <div>loading (Chat App)</div>}
      {!loading && 
    
        ob._embedded.messageThreads.map( e => (
            <ThreadWrapperDiv key={e.id}>
            <MessageThreadHead user={account} chatBubbleCallBack={(id) => createBubbleHead(id)} 
                newMessages={newMessages}
                scrollCenterCallback={(x) => scrollCenter(x)}
                newMessagesCallback={(r,id) => newMessagesProp(r,id)}                
                numNewMessages={numNewMessages[getThreadId(e)]}
                {...e} />
            </ThreadWrapperDiv>
        ))}
        {!loading && ob._embedded.messageThreads.length === 0 &&
            <button onClick={() => alert("Not yet developed")}>Set up Quick Chat (dev)</button>}
     </ChatDiv>
    );}
  }

  App.propTypes = {
  };
  
  export default App;